import React from 'react'

function Header() {
    return (
        <header className="header">
             <h1 className="header-text">25+5 Clock</h1>
        </header>
    )
}

export default Header
